import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

export const withCustomerFilters = ComponentToWrap => {
  class CustomerFiltersComponent extends PureComponent {
    static propTypes = {
      sessionPreferences: PropTypes.object,
      userMetadata: PropTypes.object
    };

    static defaultProps = {
      sessionPreferences: {},
      userMetadata: {}
    };

    get customersFilters() {
      const { customersFilters: metadataCustomersFilters } = this.props.userMetadata;
      const { customersFilters: sessionCustomersFilters } = this.props.sessionPreferences;

      return sessionCustomersFilters || metadataCustomersFilters;
    }

    render() {
      return <ComponentToWrap {...this.props} customersFilters={this.customersFilters} />;
    }
  }

  const mapStateToProps = state => {
    return {
      sessionPreferences: state.app.sessionPreferences,
      userMetadata: state.app.userMetadata
    };
  };

  return connect(mapStateToProps)(CustomerFiltersComponent);
};



// WEBPACK FOOTER //
// ./src/components/Common/Preferences/withCustomerFilters.js